import { listLanguage, getLanguagePackage } from '@/api/language'
import { setStore, getStore, removeStore, setExpire, getExpire } from '@/util/util'
import constant from '@/config/constant'

const state = {
  languageList: [],
  languagePackage: {}
}

const getters = {
  getLanguageList: () => {
    return state.languageList;
  }
}

const mutations = {
  SET_LANGUAGELIST: (state, languageList) => {
    state.languageList = languageList
    setExpire(constant.LANGUAGE, languageList, 30*60*1000);
  }
}

const actions = {
  // 获取语言列表
  listLanguage({commit}) {
    //const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      let list = getExpire(constant.LANGUAGE);
      if(list) {
        commit('SET_LANGUAGELIST', list)
        resolve();
        return;
      }
      listLanguage().then(response => {
        const { data } = response
        let languageList1 = [];
        for(let item of data) {
          let newItem = {'languageid':item.id, 'languagename': item.languagename, 'languagecode': item.languagecode};
          languageList1[languageList1.length] = newItem;
        }
        commit('SET_LANGUAGELIST', languageList1)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js